import _ from 'lodash';

(() => {
  angular
    .module('finance')
    .controller('finance.views.accountOwners.editBankDetailsModal', EditBankDetailsModalController);

  EditBankDetailsModalController.$inject = [
    '$scope',
    '$uibModalInstance',
    'abp.services.finance.accountOwners',
    'abp.services.finance.commonLookup',
    'Hms.Finance.Banks.PaymentMode',
    'accountOwnerId',
    'countryCode',
  ];

  function EditBankDetailsModalController(
    $scope,
    $uibModalInstance,
    accountOwnerSvc,
    commonLookupSvc,
    enumPaymentMode,
    accountOwnerId,
    countryCode
  ) {
    const vm = this;

    vm.loading = 0;
    vm.bankDetails = null;
    vm.banks = [];

    vm.cancel = cancel;
    vm.confirm = confirm;
    vm.getBanks = getBanks;

    init();

    function init() {
      vm.loading += 1;

      getBanks();

      accountOwnerSvc
        .getAccountOwnerBankAccountDetails({ id: accountOwnerId })
        .success((data) => {
          vm.bankDetails = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getBanks() {
      commonLookupSvc
        .getBanks({ filter: countryCode })
        .success((data) => {
          if (data) {
            localizeBankPaymentModes(data.items);
            vm.banks = data.items;
          }
        })
        .finally(() => {});
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function confirm() {
      const isValid = App.isFormValid($scope.editBankDetailsForm);
      if (isValid) {
        vm.saving += 1;
        accountOwnerSvc
          .updateAccountOwnerBankAccountDetails(vm.bankDetails)
          .success(() => {})
          .finally(() => {
            vm.saving -= 1;
            $uibModalInstance.close();
          });
      }
    }

    function localizeBankPaymentModes(data) {
      _.forEach(data, (bank) => {
        bank.paymentModeDisplayName = App.localize(
          _.find(enumPaymentMode, (paymentMode) => paymentMode.id === bank.bankPaymentMode).name
        );
      });
    }
  }
})();
